import React, { useMemo } from 'react';
import { HubBoardIcon, sortHubBoards } from '../utils/hubSidebarUtils';

/**
 * Sidebar com lista de quadros (boards) — estilo menu de ações + chips do board.
 * countKey: campo do board usado no badge ('postCount' para Sugestões, 'roadmapCount' para Roadmap).
 */
const HubSidebar = ({ boards, selectedBoardId, onSelectBoard, countKey = 'postCount' }) => {
  const sortedBoards = useMemo(() => sortHubBoards(boards), [boards]);

  return (
    <aside className="hub-feedback-sidebar" aria-label="Módulos">
      <nav className="hub-feedback-sidebar-nav">
        <div className="hub-feedback-sidebar-nav-header">
          <span className="hub-feedback-breadcrumb-segment hub-feedback-sidebar-nav-label">Módulos</span>
        </div>
        {sortedBoards.map((board) => {
          const isSelected = selectedBoardId === board.id;
          const badgeCount = board[countKey];
          return (
            <button
              type="button"
              key={board.id}
              className={`hub-feedback-sidebar-item${isSelected ? ' is-active' : ''}`}
              onClick={() => onSelectBoard(board.id)}
              aria-current={isSelected ? 'page' : undefined}
            >
              <HubBoardIcon boardName={board.name} className="hub-feedback-sidebar-item-icon" />
              <span className="hub-feedback-sidebar-item-text">
                <span className="hub-feedback-sidebar-item-label">{board.name}</span>
                {badgeCount != null && badgeCount > 0 ? (
                  <span
                    className="ec-av-kanban-group-pill-badge hub-feedback-sidebar-badge"
                    aria-label={`${badgeCount} sugestões`}
                  >
                    {badgeCount}
                  </span>
                ) : null}
              </span>
            </button>
          );
        })}
      </nav>
    </aside>
  );
};

export default HubSidebar;
